/** Happy Tree Valley Tunes — stream-only MP3s in `public/music/`. */
export const MUSIC_PREVIEW_SECONDS = 20;

export const HAPPY_TREE_VALLEY_TUNES = [
  {
    id: 'libby-theme',
    title: 'Libby Theme (Original)',
    description: 'The heart of Happy Tree Valley — Libby’s signature song.',
    fileName: 'libby-theme.mp3',
  },
  {
    id: 'abc-song-complete',
    title: 'Sing ABCs with Libby',
    description: 'Sing the alphabet from A to Z with Libby and friends.',
    fileName: 'libby-abc-song-complete.mp3',
  },
  {
    id: 'Sing ABCs with Libby - Extended Play',
    title: 'ABC Song (Full)',
    description: 'A full-length ABC adventure for little singers.',
    fileName: 'libby-abc-song-full.mp3',
  },
  {
    id: 'theme-ampiano',
    title: 'Libby Theme (Ampiano)',
    description: 'A warm, bouncy Ampiano remix of Libby’s theme.',
    fileName: 'libby-theme-ampiano.mp3',
  },
  {
    id: 'theme-jersey-club',
    title: 'Libby Theme (Jersey Club)',
    description: 'High-energy Jersey Club beats for dance-along fun.',
    fileName: 'libby-theme-jersey-club.mp3',
  },
  {
    id: 'theme-memphis-club',
    title: 'Libby Theme (Memphis Club)',
    description: 'Memphis Club flair — perfect for wiggles and giggles.',
    fileName: 'libby-theme-memphis-club.mp3',
  },
];

export function musicAssetUrl(fileName) {
  return `${process.env.PUBLIC_URL || ''}/music/${fileName}`;
}
